import {
  Button,
  ButtonGroup,
  Card,
  Form,
  FormSubmitHandler,
  Separator,
  FormButton,
} from 'platform/components';
import {Heading, Space} from 'platform/foundation';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';

import {BranchSection} from './BranchSection';
import {cashRegisterLimitValidationSchema} from './cashRegisterLimitValidationSchema';
import {RestrictionList} from './RestrictionList';
import {DefinitionFormType} from './types';

interface CashRegisterLimitFormProps {
  defaultValues?: DefinitionFormType;
  isSystem: boolean;
  edit: boolean;
  onSubmit: FormSubmitHandler<DefinitionFormType>;
  cancelRoute: string;
}

export function CashRegisterLimitForm(props: CashRegisterLimitFormProps) {
  return (
    <Form<DefinitionFormType>
      mode="onChange"
      experimentalZodSchema={cashRegisterLimitValidationSchema(props.defaultValues)}
      onSubmit={props.onSubmit}
      defaultValues={props.defaultValues}
      shouldWatchForUnsavedChanges
    >
      {(control, formApi, navigateWithoutBlocker) => (
        <Card>
          <Heading size={4}>
            {props.edit
              ? i18n.t('page.accounting.labels.editDefinition')
              : i18n.t('page.accounting.labels.newDefinition')}
          </Heading>
          <Separator />
          <BranchSection control={control} edit={props.edit} isSystem={props.isSystem} />
          <Space vertical={4} />
          <RestrictionList control={control} />
          <Separator />
          <ButtonGroup align="right">
            <Button
              isDisabled={formApi.formState.isSubmitting}
              variant="secondary"
              onClick={() => navigateWithoutBlocker(props.cancelRoute)}
              title={i18n.t('general.actions.cancel')}
              data-testid={testIds.settings.cashLimitsAdd('cancel')}
            />
            <FormButton
              control={control}
              variant="primary"
              type="submit"
              title={props.edit ? i18n.t('general.actions.save') : i18n.t('general.actions.create')}
              data-testid={testIds.settings.cashLimitsAdd('submit')}
            />
          </ButtonGroup>
        </Card>
      )}
    </Form>
  );
}
